export default __webpack_public_path__ + "static/media/icono_tabla.130531c9.svg";